'use strict';

angular.module('webmailWrapper')
    .service('spamProfiles', function($http, translationProvider) {
        function returnProfiles(result) {
            result.data.profiles.forEach(profile => {

                profile.label = translationProvider.instant(profile.label);
                if (profile.name !== 'individual') {
                    profile.desc = translationProvider.instant(profile.desc);
                }

            });

            return result.data.profiles;
        }

        this.getProfiles = function() {
            return $http.get('/data/spamProfiles.json', {cache: true})
                .then(returnProfiles);
        };
    });
